import styled from "styled-components";

type RightStyleTypes = {
  className?: string;
  text?: boolean;
};
type LeftStyleTypes = {
  className?: string;
  text?: boolean;
};

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-4 mt-6 mb-5",
})``;

const HalfWidth = styled.div.attrs({
  className: "sm:w-full md:w-6/12 flex flex-col gap-4",
})``;

const Line = styled.hr.attrs({
  className: "bg-[#F8F7F7] my-5 w-full",
})``;

const Left = styled.p.attrs<LeftStyleTypes>((props) => ({
  className: `font-bold + ${props.className}`,
}))``;

const Right = styled.p.attrs<RightStyleTypes>((props) => ({
  className: `col-span-2 + ${props.className}`,
}))<RightStyleTypes>``;

const Footer = styled.div.attrs({
  className:
    "w-fit ml-auto mt-5 flex gap-12 content-center items-center hover:text-black",
})``;

export default {
  FormContainer,
  HalfWidth,
  Line,
  Left,
  Right,
  Footer,
};
